import { jsxs, jsx } from 'react/jsx-runtime';
import { MarkdownContent } from '@backstage/core-components';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  markdownDescription: {
    fontSize: theme.typography.caption.fontSize,
    margin: 0,
    color: theme.palette.text.secondary,
    "& :first-child": {
      margin: 0,
      marginTop: "3px"
      // to keep the standard browser padding
    }
  }
}));
const ScaffolderField = (props) => {
  const {
    children,
    displayLabel = true,
    rawErrors = [],
    errors,
    help,
    rawDescription,
    required,
    disabled
  } = props;
  const classes = useStyles();
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      fullWidth: true,
      error: rawErrors.length ? true : false,
      required,
      disabled,
      children: [
        children,
        displayLabel && rawDescription ? /* @__PURE__ */ jsx(
          MarkdownContent,
          {
            content: rawDescription,
            linkTarget: "_blank",
            className: classes.markdownDescription
          }
        ) : null,
        errors,
        help
      ]
    }
  );
};

export { ScaffolderField };
//# sourceMappingURL=ScaffolderField.esm.js.map
